import(/* webpackMode: "eager" */ "/data/src/app/pageLayout.tsx");
import(/* webpackMode: "eager" */ "/data/src/app/styleRegistry.tsx");
import(/* webpackMode: "eager" */ "/data/src/app/styles/global.scss")